import Baobab from 'baobab';

const tree = new Baobab({
	appCapabilities: {
		views: {
			player: {
				procedure: {
					autoSelectOnScroll: false,
					focusInputOnSelect: true
				}
			}
		},
		showMode: true

	},
	appState: {
		alerts: []
	},
	player: {
		navStack: [],
		showSpinner: false,
		showComments: false,
		showCommentsIdx:0
	},
	// Data from the SCORM adapter
	sco: {},
	// Data from the activity
	// In future could ahve multiple activites to support our linking concept
	// Would store each of them in map or array and then load proper one
	// We should have our own packaging spec to pull off easily
	rootActivityId: "",
	activity: {},
	activities: [],
	user: {
		// Simulate user
		identityId: "test-identity-id"
	},
	associatedContentCard: {
		show: false
	}
},
	{
		immutable: false
	});

export default tree;